import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import FlxGrid from "../../../../../../_src_shared/components/layout/FlxGrid";
import BorrowerSummaryCardItem from "./BorrowerSummaryCardItem";
import Flx from "../../../../../../components/layout/Flx";
const CARD_WIDTH = 300;
// const CARD_WIDTH = 680;
const BorrowerSummaryCardList = ({ activeBorrowerData }) => {
  const borrowers = useSelector(
    (state) => state?.loanDrilldown?.borrowers || []
  );

  return (
    <Flx
      gap={2.5}
      // grow={1}
      fw
      //
      wrap
      sx={{ alignItems: "flex-start" }}
      // ac
      jc
    >
      {borrowers.map((borrower) => (
        <BorrowerSummaryCardItem
          key={borrower._id}
          activeBorrowerId={activeBorrowerData?._id}
          borrower={borrower}
        />
      ))}
    </Flx>
  );
  // return (
  //   <FlxGrid width={`${CARD_WIDTH}px`} gap={2.5} grow={1}>
  //     {borrowers.map((borrower) => (
  //       <BorrowerSummaryCardItem
  //         key={borrower._id}
  //         activeBorrowerId={activeBorrowerData?._id}
  //         borrower={borrower}
  //       />
  //     ))}
  //   </FlxGrid>
  // );
};

export default BorrowerSummaryCardList;
